"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var react_router_dom_1 = require("react-router-dom");
var useWindowSize_1 = __importDefault(require("hooks/useWindowSize"));
var store_1 = require("components/store");
var ui_1 = require("components/ui");
var our_stores_module_sass_1 = __importDefault(require("./our-stores.module.sass"));
var react_i18next_1 = require("react-i18next");
var axios_1 = __importDefault(require("axios"));
var OurStores = function () {
    var deviceWidth = (0, useWindowSize_1["default"])().deviceWidth;
    var t = (0, react_i18next_1.useTranslation)().t;
    var _a = (0, react_1.useState)([]), shops = _a[0], setShops = _a[1];
    var shopsRef = (0, react_1.useRef)(shops);
    shopsRef.current = shops;
    var getShops = (0, react_1.useCallback)(function () { return __awaiter(void 0, void 0, void 0, function () {
        var response_1, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, axios_1["default"].post("".concat(process.env.REACT_APP_BASE_URL, "/shops"))];
                case 1:
                    response_1 = _a.sent();
                    setShops(function (prevShops) { return __spreadArray(__spreadArray([], prevShops, true), response_1.data, true); });
                    console.log(response_1.data, "response.dataOurStore");
                    return [3 /*break*/, 3];
                case 2:
                    error_1 = _a.sent();
                    console.error(error_1);
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); }, [shopsRef]);
    (0, react_1.useEffect)(function () {
        getShops();
    }, []);
    return ((0, jsx_runtime_1.jsxs)(ui_1.Section, __assign({ id: "stores", relative: true }, { children: [(0, jsx_runtime_1.jsx)("div", { className: our_stores_module_sass_1["default"].background }), (0, jsx_runtime_1.jsx)("div", __assign({ className: "container", style: { position: "relative" } }, { children: (0, jsx_runtime_1.jsxs)(ui_1.FadeIn, { children: [(0, jsx_runtime_1.jsx)(ui_1.Text, __assign({ as: "h2", color: "blue-dark", align: deviceWidth === "large" ? "start" : "center" }, { children: t("Наши магазины") })), (0, jsx_runtime_1.jsxs)(ui_1.Text, __assign({ style: { fontWeight: 500 }, as: "p", size: deviceWidth === "large" ? "lg" : "sm", className: "offset-top-30", align: deviceWidth === "large" ? "start" : "center" }, { children: [t("В нашей экосистеме находится более "), (0, jsx_runtime_1.jsx)("span", __assign({ style: { display: "inline-block" } }, { children: "1 000 000" })), " ", t("ваших любимых магазинов, в любой из которых можно попасть, не выходя из дома или занимаясь своим любимым делом. Мы делаем всё, чтобы вам было комфортно!")] }))] }) })), (0, jsx_runtime_1.jsxs)("div", __assign({ className: "offset-top-30" }, { children: [(0, jsx_runtime_1.jsx)(ui_1.FadeIn, __assign({ className: our_stores_module_sass_1["default"]["carousel-wrapper"], delay: 0.5 }, { children: (0, jsx_runtime_1.jsxs)(ui_1.Carousel, __assign({ loop: true, centeredSlides: deviceWidth === "large", allowTouchMove: true, slidesPerView: 2, spaceBetween: 10, navigation: deviceWidth === "large", autoplay: {
                                delay: 5000,
                                disableOnInteraction: false
                            }, breakpoints: {
                                sm: {
                                    slidesPerView: 3
                                },
                                md: {
                                    slidesPerView: 4
                                },
                                lg: {
                                    slidesPerView: 5
                                },
                                xl: {
                                    slidesPerView: 5,
                                    spaceBetween: 20
                                },
                                xxl: {
                                    slidesPerView: 6,
                                    spaceBetween: 20
                                },
                                xxxl: {
                                    slidesPerView: 7,
                                    spaceBetween: 20
                                }
                            } }, { children: [shops.map(function (shop) { return ((0, jsx_runtime_1.jsx)(ui_1.SlideItem, { children: (0, jsx_runtime_1.jsx)(store_1.Store, { shop: shop }) })); }), (0, jsx_runtime_1.jsx)(ui_1.Screen, __assign({ size: "xl" }, { children: (0, jsx_runtime_1.jsx)("div", __assign({ className: our_stores_module_sass_1["default"]["all-stores"] }, { children: (0, jsx_runtime_1.jsx)("div", __assign({ className: "container" }, { children: (0, jsx_runtime_1.jsx)(react_router_dom_1.Link, __assign({ to: "categories" }, { children: (0, jsx_runtime_1.jsx)(ui_1.Button, __assign({ view: "secondary" }, { children: t("Все магазины") })) })) })) })) }))] })) })), (0, jsx_runtime_1.jsx)(ui_1.Screen, __assign({ size: "xl", down: true }, { children: (0, jsx_runtime_1.jsx)("div", __assign({ className: our_stores_module_sass_1["default"]["all-stores"] }, { children: (0, jsx_runtime_1.jsx)("div", __assign({ className: "container" }, { children: (0, jsx_runtime_1.jsx)(react_router_dom_1.Link, __assign({ to: "categories" }, { children: (0, jsx_runtime_1.jsx)(ui_1.Button, __assign({ view: "secondary" }, { children: t("Все магазины") })) })) })) })) }))] }))] })));
};
exports["default"] = OurStores;
